import React from 'react';
import { Text, Box } from '@rsos/components/capstone/base';

const OutboundAlertsNoAlertsAccess = () => {
  return (
    <Box justify="center" align="center" height="100%" flow={4}>
      <Text size="large" color="secondaryText" fontWeight="semibold">
        Alerts not enabled
      </Text>
      <Text size="normal" color="secondaryText">
        Your agency currently does not have alerts enabled. Please contact
        RapidSOS to enable alerts.
      </Text>
    </Box>
  );
};

export default OutboundAlertsNoAlertsAccess;
